/* eslint-disable no-empty-pattern */
import kitsu from '@plugins/kitsu';
import { queryString } from '../../../utils/format';
import http from '@plugins/axios';
let $ajax;

export const state = {
  api: null,
};

export const mutations = {
  SET_API(state, newValue) {
    state.api = newValue;
  },
};

export const actions = {
  async fetch({ commit, rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const api = payload && payload.attr && payload.attr.api;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/${api}`,
    });

    commit('SET_API', api);
    return await $ajax.get('/', { params: payload.params });
  },

  async getDetail({ commit, rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const api = payload && payload.api;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/${api}`,
    });
    commit('SET_API', api);
    return await $ajax.get(`/${payload.id}`).then(({ data }) => data);
  },

  async getInstrument({ rootState, state }, payload) {
    const id = rootState.auth.instansi_id;
    const api = state.api || 'kp';
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/${api}/${payload.id}/sekolah/${payload.sekolah_id}`,
    });
    return await $ajax.get(`/`, { params: payload.params });
  },

  async getKandidat({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/kp/sekolah`,
    });
    return await $ajax.get(`/`, { params: payload.params });
  },

  async getSekolah({ rootState, state }, payload) {
    const id = rootState.auth.instansi_id;
    const api = state.api || 'kp';
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/${api}/${payload.id}/sekolah`,
    });
    return await $ajax.get(`/`, { params: payload.params });
  },

  async getPic({ rootState }) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/pendampingan/opsi`;
    return await http.get(url).then(({ data }) => data);
  },

  async getInstruktur({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/i/${id}/kp/instruktur`,
    });
    return await $ajax.get(`/`, { params: payload.params });
  },

  create({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/kp/create`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  update({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/kp/${payload.id}/update`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  updatePendampingan({ rootState, state }, payload) {
    const id = rootState.auth.instansi_id;
    const api = state.api || 'kp';
    const url = `/psp/i/${id}/${api}/${payload.id}/update${api === 'kp' ? '-pendampingan' : ''}`;
    return http.post(url, payload.params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  updateLaporan({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/pendampingan/${payload.id}/update-laporan/${payload.sekolah_id}`;
    return http.post(url, payload.params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  delete({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `/psp/i/${id}/kp/${payload.id}/delete`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  downloadList({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `${process.env.VUE_APP_API_URL}/psp/i/${id}/kp/${payload.url}?${queryString(payload.params)}`;
    return Promise.resolve(url);
  },
};
